var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBloodgroupDuoToneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "235.431 130.74 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_95308",
    "data-name": "Group 95308",
    transform: "matrix(0.75, 0, 0, 0.75, 164.179773, -1480.261175)",
    style: {}
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blood_group_icon",
    "data-name": "blood group icon",
    transform: "translate(94.667 2147.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47902",
    "data-name": "Rectangle 47902",
    width: 32,
    height: 32,
    transform: "translate(0.334 0.334)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-drop-of-blood",
    transform: "translate(2.66 1.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97302",
    "data-name": "Path 97302",
    d: "M34.464,20.718,26.3,10.5,18.133,20.718a10.3,10.3,0,1,0,16.331,0Z",
    fill: "none",
    stroke: "#252b43",
    strokeWidth: 2,
    transform: "translate(-8.585 -7.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97303",
    "data-name": "Path 97303",
    d: "M22.509,15.234,15.651,6.65,8.792,15.234a8.651,8.651,0,1,0,13.717,0Z",
    fill: "none",
    stroke: "#252b43",
    strokeWidth: 2,
    transform: "translate(-7 -6.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97304",
    "data-name": "Path 97304",
    d: "M16,27.851a10.3,10.3,0,0,0,.386,2.8q.42.041.85.041a8.64,8.64,0,0,0,6.859-13.908l-1.06-1.326-4.9,6.134A10.24,10.24,0,0,0,16,27.851Z",
    fill: "#f27d35",
    strokeWidth: 0,
    transform: "translate(-8.585 -8.202)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodgroupDuoToneIcon);
export default __webpack_public_path__ + "static/media/bloodgroupDuoToneIcon.55d3ecb1.svg";
export { ForwardRef as ReactComponent };